import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/backend/services/auth.service';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.scss'],
})
export class ConfirmEmailComponent implements OnInit {
  public form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });
  public token: any = '';
  successOrErrorMessage: string = '';
  isSignInEnabled: boolean = false;
  isError: boolean = true;
  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params: any) => {
      this.form.get('email')?.setValue(params?.email);
      this.token = params?.token;
    });
  }

  confirmEmailClick(): void {
    const data = {
      email: this.form.value.email,
      token: this.token,
    };
    this.spinner.show();
    this.successOrErrorMessage = '';
    this.isSignInEnabled = false;
    this.isError = true;
    this.authService.confirmEmail(data.email, data.token).subscribe({
      next: (response) => {
        this.successOrErrorMessage = response?.message;
        this.spinner.hide();
        this.isSignInEnabled = true;
        this.isError = false;
      },
      error: ({ error }) => {
        this.successOrErrorMessage = error?.message;
        this.spinner.hide();
        this.isSignInEnabled = false;
        this.isError = true;
      },
    });
  }

  goToLogin(): void {
    this.router.navigate([
      '/login',
    ]);
  }
}
